import { LoadableAfterPaint } from '@confluence/loadable';

export const PageTreeSearchMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageTreeSearchMacro" */ '../src/PageTreeSearchMacroRenderer.tsx'
			)
		).PageTreeSearchMacroRenderer,
});
